module.exports = __webpack_public_path__ + "static/media/campground.95bd1eb1.svg";